export function setCityRestaurants(restaurants, baseCity) {
  const city = JSON.parse(localStorage.getItem('currentCity')) || baseCity;
  const currentCityRestaurants = restaurants.filter(r =>
    r.city_uuid === city.uuid);
  content.setReservationRestaurantsField(currentCityRestaurants);
}